import React from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Col,
  Button,
} from "reactstrap";
import ButtonComponent from "../buttons/button-component";

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Col md="8" className={this.props.className}>
        <Form
          name="contact"
          method="post"
          netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <input type="hidden" name="form-name" value="contact" />
          <FormGroup>
            <Label for="inputName">Name*</Label>
            <Input
              type="text"
              name="name"
              id="name"
              className="form-control-lg"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="inputEmail">Email*</Label>
            <Input
              type="email"
              name="email"
              id="email"
              className="form-control-lg"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="inputPhone">Phone</Label>
            <Input
              type="tel"
              name="phone"
              id="phonenumber"
              className="form-control-lg"
            />
          </FormGroup>
          <FormGroup>
            <Label for="inputMessage">Message*</Label>
            <Input
              type="textarea"
              name="message"
              className="form-control form-control-lg"
              id="message"
              rows="2"
              required
            />
          </FormGroup>
          <ButtonComponent large link="/thanks">
            Send Inquiry
          </ButtonComponent>
        </Form>
      </Col>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/contact-form/contact-form.jsx